import React from "react";
import { TextField, Grid, InputLabel } from "@material-ui/core";
import { translate } from "react-i18next";
import { connect } from "react-redux";

class SocialNetworkItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    const { name, value } = event.target;
    const { defaultValue } = this.props;

    this.setState({
      [name]: value,
    });
    this.props.onChange({
      target: {
        name: "socialNetwork",
        value: { ...defaultValue, [name]: value },
      },
    });
  }
  render() {
    const { t, socialNetwork, value } = this.props;
    return (
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} sm={12} md={3}>
          <Grid container alignItems="center">
            <SocialIcon color={socialNetwork.color} icon={socialNetwork.icon} />
            <InputLabel
              style={{
                marginBottom: 0,
              }}
            >
              {socialNetwork.label}
            </InputLabel>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={9}>
          <TextField
            id={socialNetwork.value}
            name={socialNetwork.value}
            label={t("ref_link")}
            defaultValue={value}
            variant="outlined"
            fullWidth={true}
            size="small"
            type="url"
            onChange={this.handleChange}
          />
        </Grid>
      </Grid>
    );
  }
}

class SocialIcon extends React.Component {
  render() {
    return React.createElement(this.props.icon, {
      style: { color: this.props.color },
    });
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(SocialNetworkItem));
